<template>
  <div>
    <a-list
      itemLayout="horizontal"
      :dataSource="listData"
    >
      <a-list-item slot="renderItem" slot-scope="item, index" :key="index">
        <a-list-item-meta>
          <a slot="title">{{ item.title }}</a>
          <span slot="description">
            <span class="security-list-description">{{ item.description }}</span>
            <span v-if="item.value"> : </span>
            <span class="security-list-value">{{ item.value }}</span>
          </span>
        </a-list-item-meta>
        <template v-if="item.actions">
          <a slot="actions" @click="item.actions.callback">{{ item.actions.title }}</a>
        </template>
      </a-list-item>
    </a-list>

    <a-modal
      title="Modify your password"
      :visible="showChangePasswordModal"
      @ok="handleSubmit"
      @cancel="showChangePasswordModal = false"
      :maskClosable="false"
      :confirmLoading="confirmLoading"
    >
      <a-form
        layout="vertical"
        :form="editForm"
        autocomplete="off"
        class=""
      >
        <!-- 原密码 -->
        <a-form-item
          label="Old password"
          hasFeedback
        >
          <a-input
            style="-webkit-text-security:disc;"
            placeholder="Please input old password (6-20 character)"
            v-decorator="[
              'oldPassword',
              {rules: [{ min: 6, max: 20, required: true, message: 'Please input old password (6-20 character)' }]}
            ]"
          ></a-input>
        </a-form-item>
        <!-- 新密码 -->
        <a-form-item
          label="New password"
          hasFeedback
        >
          <a-input
            style="-webkit-text-security:disc;"
            placeholder="Please input new password (6-20 character)"
            v-decorator="[
              'newPassword',
              {rules: [{ min: 6, max: 20, required: true, message: 'Please input new password (6-20 character)' }]}
            ]"
          ></a-input>
        </a-form-item>
      </a-form>
    </a-modal>

  </div>
</template>

<script>
import { changeMyPassword } from '@/api/api-adminer'

export default {
  data () {
    return {
      listData: [
        { title: 'Account password', description: 'Current password strength', value: 'Strong', actions: { title: 'Change Password', callback: () => { this.showChangePasswordModal = true } } }
      ],
      editForm: this.$form.createForm(this),
      showChangePasswordModal: false,
      confirmLoading: false
    }
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      const that = this
      // eslint-disable-next-line
      that.editForm.validateFields((err, fieldsValue) => {
        // 如果校验失败直接返回
        if (err) {
          return
        }
        var formData = this.editForm.getFieldsValue()
        console.log('formData', formData)
        that.confirmLoading = true
        changeMyPassword(formData)
          .then(res => {
            console.log('res', res)
            that.confirmLoading = false
            if (res.success) {
              that.mixinProcessSuccessNotification('Password change successfully !')
              that.showChangePasswordModal = false
            } else {
              that.mixinProcessHasBizErrorNotification(res)
              console.log('e', res)
            }
          })
          .catch(e => {
            that.mixinErrorNotification(`Change fail: ${e.message}`)
            that.confirmLoading = false
            console.log('e', e)
          })
      })
    },
    // 加载表单数据
    loadEditInfo () {
      var formData = { 'oldPassword': null, 'newPassword': null }
      this.editForm.setFieldsValue(formData)
    }
  }
}
</script>

<style scoped>

</style>
